import React from 'react';
import styled from 'styled-components';

import { getAppText } from 'Utils/text';
import { useGetAkaPartnerLogo } from '../../PartnerTheme/partnerTheme.hooks';
import { PARTNER_FOOTER_IN_COOPERATION_WITH } from '../../themes.constants';

export const InCorporationWithAkademikerne = (): React.ReactElement => {
  const logo = useGetAkaPartnerLogo();
  return (
    <Container>
      <Text>{getAppText(PARTNER_FOOTER_IN_COOPERATION_WITH)} </Text>
      <Logo alt="Akademikerne logo" src={logo} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
`;

const Text = styled.span`
  white-space: nowrap;
  line-height: 27px;
`;

const Logo = styled.img`
  margin-left: 8px;
  height: 18px;
`;
